import { PropsWithChildren, ReactElement } from 'react'
import './FormBox.scss'

interface FormBoxProps extends PropsWithChildren {
  icon?: string
  title?: string
  className?: string
  actions?: ReactElement
}

export function FormBox(props: FormBoxProps) {
  return (
    <div className="form-box">
      {(!!props.icon || !!props.title) && (
        <div className="form-box-header">
          <div className="form-box-header-left">
            {!!props.icon && <i className={props.icon} />}
            {props.title}
          </div>
          <div className="form-box-header-right">{props.actions}</div>
        </div>
      )}
      <div className="form-box-content">{props.children}</div>
    </div>
  )
}
